package com.swetdot.swetgram.ui.tasks

import com.swetdot.swetgram.data.realtime.RealtimeSignal
import com.swetdot.swetgram.protocol.dto.RealtimeEventTypes

/** Tasks socket frames are refresh hints only; REST remains the complete state. */
internal fun RealtimeSignal.refreshesTasks(): Boolean = when (this) {
    RealtimeSignal.Resynchronize -> true
    is RealtimeSignal.Event -> event.type in TASKS_HINTS
    is RealtimeSignal.Read, is RealtimeSignal.Typing -> false
}

private val TASKS_HINTS = setOf(
    RealtimeEventTypes.TASKS_PROGRESS_UPDATED,
    RealtimeEventTypes.TASKS_TASK_COMPLETED,
    RealtimeEventTypes.TASKS_SET_COMPLETED,
    RealtimeEventTypes.TASKS_NEW_DAY_AVAILABLE,
)
